import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.cuentasBancarias.detalle.editar.prestamos.agregar', {
    template: '<finances-posicionbancaria-prestamos-agregar id-empresa="idEmpresa" id-cuenta="idCuenta" on-close="cerrar($event.data)"></finances-posicionbancaria-prestamos-agregar>',
    url: '',
    data: {title: 'Nuevo'},
    controller ($scope, idEmpresa, idCuenta, $state) {
      $scope.idEmpresa = idEmpresa
      $scope.idCuenta = idCuenta
      $scope.cerrar = cerrar

      function cerrar () {
        $state.go('^.lista')
      }
    },
  })
})








// WEBPACK FOOTER //
// ./src/finanzas/_/bancosCuentas/routes/cuentasBancarias/detalle/editar/prestamos/nuevo.js